import GradeBreakdownChart from 'libs/grade-breakdown-chart';

export default function(data) {
  var self = this;

  self.selectedOffering = ko.observable();
  self.enrollment_type = ko.observable();
  self.initial_enrollment_type = ko.observable();

  self.$el = $('#course_info');

  self.course = ko.observable();
  self.justEnrolled = ko.observable(false);

  self.enrollment_fields_info = ko.observable({});

  self.enrollment_fields_group = ko.computed(function() {
    if (!self.course())
      return {};
    return _.groupBy(self.course().enrollment_fields(), function(field) {
      return field.section();
    });
  });

  self.bindData = function (data) {
    var mapped_course = ko.mapping.fromJS(data);

    self.course(mapped_course);

    if (self.course().current_user) {
      self.enrollment_type(self.course().current_user.enrollment_type());
      self.initial_enrollment_type(self.enrollment_type());
    }

    self.selectedOffering.subscribe(self.switchOffering);
  };

  self.switchOffering = function(offering) {
    Kadenze.Request.pjax({
      url: Kadenze.Routes.course_info_path(offering.slug()),
      container: $('#main-pjax-container')
    });
  };

  self.notifyMe = function() {
    var btn = $('#notify-btn')[0];
    var loader = Ladda.create(btn);

    loader.start();

    var req = Kadenze.AjaxRequest({
      url: Kadenze.Routes.notify_me_course_path(self.course().id())
    });

    req.done(function(response) {
      new Kadenze.Notice.success({message: response.message});
      $(btn).fadeOut();
    });

    req.fail(function(data) {
      new Kadenze.Notice.error({message: data.responseJSON.message});
    });

    req.always(function() {
      loader.stop();
    });
  };

  self.userPresent = function() {
    return true;
  };

  self.hasEnrollmentFields = function() {
    return self.course() && self.course().enrollment_fields().length > 0;
  };

  self.forCreditInfo = function(attrObs) {
    return ko.computed({
      read: function() {
        return self.enrollment_fields_info()[attrObs()] || null;
      },

      write: function(val) {
        self.enrollment_fields_info()[attrObs()] = val;
        self.enrollment_fields_info.valueHasMutated();
      }
    });
  };

  self.handleEnrollmentRequest = function(vm, evt) {
    if (self.hasEnrollmentFields()) {
      $('#js-course-enroll-modal--options').modal('hide');
      $('#js-course-enroll-modal--fields').modal('show');
    } else {
      self.enroll(vm, evt);
    }
  };

  self.submitEnrollmentFields = function(vm, evt) {
    let loader = Ladda.create(evt.target);
    let data;

    loader.start();

    if (self.course().current_user && self.course().current_user.for_credit_info) {
      data = {user: {for_credit_info: ko.mapping.toJS(self.course().current_user.for_credit_info)} };
      data.user.for_credit_info = _.extend(data.user.for_credit_info, ko.mapping.toJS(self.enrollment_fields_info));
    } else {
      data = {user: {for_credit_info: ko.mapping.toJS(self.enrollment_fields_info)}};
    }

    let req = new Kadenze.AjaxRequest({
      type: 'PUT',
      url: Kadenze.Routes.users_path(),
      data: data
    });

    req.done(function(res) {
      self.enroll(vm, evt);
    });

    req.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.errors;
      }
      new Kadenze.Notice.error({message: msg});
    });

    req.always(function() {
      loader.stop();
    });
  };

  self.enroll = function(vm, evt) {
    var loader = Ladda.create(evt.target);

    loader.start();

    self.trackEnrollment(self.enrollment_type());

    var req = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.course_enroll_path(self.course().id()),
      data: { type: self.enrollment_type() }
    });

    req.done(function(res) {
      if (res && res.redirect_path)
        window.location.pathname = res.redirect_path;
    });

    req.fail(function(xhr, status, msg) {
      if (xhr.responseJSON)
        msg = xhr.responseJSON.errors;

      new Kadenze.Notice.error({message: msg});

      loader.stop();
    });

  };

  self.trackEnrollment = function(enrollmentType) {
    if (enrollmentType && enrollmentType == 'credit') {
      ga('send', { hitType: 'event', eventCategory: 'enrollment',
        eventAction: 'enroll_as_credit_eligible', eventLabel: self.course().name()
      });
    } else {
      ga('send', { hitType: 'event', eventCategory: 'enrollment',
        eventAction: 'enroll', eventLabel: self.course().name()
      });
    }

    var tracking_data = { new_role: enrollmentType };

    Kadenze.Analytics.track('student_ui', 'enrollment_changed', tracking_data);

    return true;
  };

  self.removeStudent = function (item, event) {
    var url = self.course().current_user.unenroll_path();
    var method = 'DELETE';
    var deletePrompt = $(event.currentTarget).data('xconfirm');

    Kadenze.UIUtil.confirmAction(deletePrompt, function () {
      Kadenze.UIUtil.makeRequest(url, method, null, self.$el, null, function (data, textStatus, xhr) {
        self.course().current_user.is_student(false);
        self.course().current_user.is_instructor(false);
        self.course().restricted() ? self.course().current_user.is_pending(false) : self.course().current_user.is_enrolled(false);
        new Kadenze.Notice.success({ message: data.message });
      }, function (xhr, textStatus, errorThrown) {
        self.server_errors(xhr.responseJSON);
      });
    });
  };

  self.initializeVideo = function() {
    var $vidWrapper = $('#vid-player');
    var promo_vid = self.course().course_promo_video;

    if (promo_vid) {
      var vid = promo_vid;
      var mediaUrls = {
        h264_360_url: vid.h264_360_url ? vid.h264_360_url() : '',
        h264_720_url: vid.h264_720_url ? vid.h264_720_url() : ''
      };

      var mediaSubtitles = ko.toJS(vid.subtitles);

      var opts = {
        poster: self.course().cinema_logo()
      };
      vid.renderer = new Kadenze.VideoPlayer($vidWrapper, mediaUrls, 'vjs-student-skin', mediaSubtitles, null, opts);
      vid.renderer.show();
      // vid.monitor = new Kadenze.MediaSessionMonitor(user_id, media_id, vid.renderer);
    }
  };

  self.buildChart = function() {
    setTimeout(function(){GradeBreakdownChart.init('horizontal');}, 300);
  };

  self.showEnrollOptions = function() {
    $('#js-course-enroll-modal--options').modal('show');
    Kadenze.WebApp.initFormElements($('#js-course-enroll-modal--options'));
  };

  self.initTabs = function() {
    $('li.tab-subnav__tab:first-child a').tab('show');
    $('body').off('shown.bs.tab', 'a.tab-subnav__tab-link').on('shown.bs.tab', 'a.tab-subnav__tab-link', function(){
      $('.js-carousel').slick('refresh');
    });
  };

  self.enrollmentTypeText = ko.computed(function() {
    return Kadenze.I18n.t('course.info.enrollment_type.' + self.initial_enrollment_type());
  });


  const __construct = function (that) {
    console.log('constructor called for CourseInfoViewModel');
    that.bindData(data);
    that.buildChart();
    that.initializeVideo();
    that.initTabs();

    var change_enrollment = Kadenze.Util.getParameterByName('change_enrollment');
    if (!_.isEmpty(change_enrollment)) {
      self.showEnrollOptions();
    }
  }(this);
}
